<template>
  <div class="chat-library-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="param.prizeType" size="small" placeholder="请选择奖品类型" clearable style="width:200px;margin-right:5px">
        <el-option v-for="item in type" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="param.status" size="small" placeholder="请选择状态" clearable style="width:200px;margin-right:5px">
        <el-option v-for="item in statusType" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="success" size="small" @click="searchBtn()">搜索</el-button>
      <el-button type="primary" size="small" @click="addContent('add')">+新增配置</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" max-height="600">
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.createTime | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="finishCondition" label="达成条件(天/活跃值)" align="center" min-width="120"></el-table-column>
      <el-table-column prop="type" label="奖品类型" align="center" :formatter="formatterType">
      </el-table-column>
      <el-table-column prop="prizes" label="奖品列表" align="center" min-width="200" :formatter="formatterPrize"> </el-table-column>
      <el-table-column prop="title" label="任务标题" align="center" min-width="120">
        <template slot-scope="scope">
          {{scope.row.title || "-"}}
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="任务描述" align="center" min-width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.desc || "-"}}
        </template>
      </el-table-column>
      <el-table-column prop="count" label="状态" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="请在编辑中修改" placement="top-start">
            <el-switch v-model="scope.row.status" disabled></el-switch>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" icon="el-icon-edit" @click="addContent('edit',scope.row)" round plain type="warning">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <add-content ref="addContent" @handlerContent="getContentList('status')" :prizeBox="prizeBox"></add-content>
  </div>
</template>
<script>
import API from "@/api";
import addContent from "./components/addContent";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      statusType: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      type: [
        {
          label: "签到福利",
          value: 1,
        },
        {
          label: "宝箱福利",
          value: 2,
        },
        {
          label: "消费回馈(站群)",
          value: 3,
        },
        {
          label: "消费回馈(棋牌)",
          value: 4,
        },
      ],
      param: {
        pageNumber: 1,
        pageSize: 10,
        prizeType: "",
        status: "",
      },
      prizeBox: [],
    };
  },
  components: {
    addContent,
  },
  created() {
    this.getContentList();
    this.queryPrizeBox();
  },
  methods: {
    getParams() {
      let req = {
        pageNumber: this.param.pageNumber,
        pageSize: this.param.pageSize,
      };
      req.type = this.param.prizeType ? this.param.prizeType : undefined;
      req.status = this.param.status != null ? this.param.status : undefined;
      return req;
    },
    queryPrizeBox() {
      API.queryPrizeBox()
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.prizeBox = res.data;
            return;
          }
          this.$message.error(res.msg || "获取奖品失败");
          this.prizeBox = [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getContentList() {
      this.loading = true;
      let req = this.getParams();
      API.querySigninConfig(req)
        .then((res) => {
          if (res.code === 200 && res.data.list.length > 0) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    formatterType(row) {
      return this.type.filter((item) => item.value == row.type).length > 0
        ? this.type.filter((item) => item.value == row.type)[0].label
        : "未知类型";
    },
    formatterPrize(row) {
      var htmlStr = "";
      if (this.prizeBox.length === 0 || row.prizes === 0) {
        return "获取奖品列表失败";
      }
      this.prizeBox.forEach((data) => {
        row.prizes.forEach((value) => {
          if (data.value == value) {
            htmlStr += "、" + data.label;
          }
        });
      });
      htmlStr = htmlStr.substr(1, htmlStr.length);
      return htmlStr;
    },
    searchBtn() {
      this.getContentList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getContentList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getContentList();
    },
    // 打开编辑、添加弹窗
    addContent(type, data) {
      this.$refs.addContent.open(type, data);
    },
  },
};
</script>